import type { DashboardSnapshot, WorkspaceRole } from './types'

// Dashboard/Chat/Settings are sibling top-level routes (see App.tsx), not nested
// under a shared layout — so navigating away from /dashboard unmounts DashboardPage
// entirely, and useDashboard() loses all state. Without this, coming back to
// /dashboard re-runs the full workspace lookup + snapshot fetch from a blank
// skeleton every time, even seconds after the last visit. A module-level (not
// React state) cache survives the unmount; useDashboard seeds its initial state
// from it so a repeat visit renders the last-known snapshot immediately while a
// fresh fetch updates it in the background. Reset only by a full page reload,
// which every logout/session-expiry path already does (see authToken.ts,
// ProfileSection.tsx's handleLogout) — so it can never leak across accounts.
type CachedDashboard = {
  workspaceId: string
  role: WorkspaceRole
  snapshot: DashboardSnapshot
}

let cached: CachedDashboard | null = null

export function getCachedDashboard(): CachedDashboard | null {
  return cached
}

export function setCachedDashboard(entry: CachedDashboard): void {
  cached = entry
}
